module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/thread-loader/dist/cjs.js!../../../../../../node_modules/babel-loader/lib/index.js??ruleSet[1].rules[0].use[1]!./GameIconWildPlanet.js"));
	}, "GameIconWildPlanet");
}